import FTAIssuedDataTableFilter from '../components/data-table/FTAIssuedDataTableFilter';
import DataTable from '../components/DataTable';
import DocumentLink from '../components/DocumentLink';
import Heading from '../components/Heading';
import { useGlobalState } from '../contexts/GlobalStateProvider';
import { IssuedColumn } from '../enums/IssuedColumn';
import { useData } from '../hooks/useData';
import { IHTSFilters } from '../interfaces/IHTSFilters';
import { IIssued } from '../interfaces/IIssued';
import { ISortDirection } from '../interfaces/ISortDirection';
import { CustomObjectParam, removeEmpty } from '../utils/objects';
import {
  useQueryParams,
  NumberParam,
  StringParam,
  BooleanParam,
  withDefault,
} from 'use-query-params';

const columns = [
  IssuedColumn.PlantCode,
  IssuedColumn.PartNumber,
  IssuedColumn.Description,
  IssuedColumn.Program,
  IssuedColumn.ProgramYear,
  IssuedColumn.CertificateNumber,
  IssuedColumn.Status,
];

const FTAIssued = () => {
  const { currentClient } = useGlobalState();

  const [query, setQuery] = useQueryParams({
    page: withDefault(NumberParam, 1),
    sortBy: withDefault(StringParam, 'Signature Date'),
    sortDirection: withDefault(StringParam, 'desc'),
    filters: withDefault(CustomObjectParam, {}),
    showFilter: withDefault(BooleanParam, false),
  });

  const {
    status,
    data: _data,
    error,
    isLoading,
    isFetching,
  } = useData({
    table: 'fta_issued',
    page: query.page,
    perPage: 50,
    sortBy: query.sortBy,
    sortDirection: query.sortDirection as ISortDirection,
    client_code: currentClient || undefined,
    ...query.filters,
  });

  const handleReportFilters = (filters: IHTSFilters) => {
    setQuery({
      ...query,
      page: 1,
      filters: removeEmpty(filters),
    });
  };

  return (
    <>
      <Heading
        title="Issued Certificates"
        reportShowFilterClick={() =>
          setQuery({ ...query, showFilter: !query.showFilter })
        }
      />
      <FTAIssuedDataTableFilter
        showFilter={query.showFilter}
        reportFilters={handleReportFilters}
      />
      <DataTable
        reportPage={(_page: number) => setQuery({ ...query, page: _page })}
        reportSort={(sortBy: keyof IIssued, sortDirection: ISortDirection) => {
          setQuery({ ...query, sortBy: sortBy as any, sortDirection });
        }}
        status={status}
        data={_data}
        error={error}
        isLoading={isLoading || isFetching}
        columns={columns}
        page={query.page}
        filters={{
          table: 'fta_issued',
          page: query.page,
          perPage: 20,
          sortBy: query.sortBy,
          sortDirection: query.sortDirection,
          ...query.filters,
        }}
        cellRenderer={(column, value) => {
          if (column === IssuedColumn.CertificateNumber) {
            return <DocumentLink certNumber={value} />;
          }

          return null;
        }}
      />
    </>
  );
};

export default FTAIssued;
